import l10n from "@src/v3.0.0/lib/l10n";
import { URL_PARAM_PRESET, URL_PARAM_PRESET_LEGACY } from "@src/var";


/**
 * Get the preset template. Returns default values ​​if no valid ones are provided.
 * @param     {object} preset - The preset object
 * @returns   {Preset} The preset template
 */
export const getPresetTemplate = (preset) => ({
  width:  Number(preset?.width),
  height: Number(preset?.height),
  rotate: Number(preset?.rotate) || 0,
  scaleX: Number(preset?.scaleX) || 1,
  scaleY: Number(preset?.scaleY) || 1,
  top:    Number(preset?.top) || 0,
  left:   Number(preset?.left) || 0,
  scale:  Number(preset?.scale) || 1,
  zoom:   Number(preset?.zoom) || 1, // (same as scale)
  media:  preset?.media,
  repeats: Number(preset?.repeats) || 1,
  isPattern: Boolean(preset?.isPattern) || false,
});

/**
 * Gets the preset string from url
 * @returns {string} Preset as string
 */
export const getFromUrl = () => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(URL_PARAM_PRESET) 
    ? urlParams.get(URL_PARAM_PRESET)
    : urlParams.get(URL_PARAM_PRESET_LEGACY);
};

/**
 * Decodes and parse a URI string as JSON
 * @param {string} str - The preset as string
 * @returns {Preset} Preset object
 */
export const parsePreset = str => {
  return JSON.parse(decodeURIComponent(str));
};

/**
 * Get the initial preset
 * @param {object} preset - Base preset configuration 
 * @returns {Preset} Always returns a preset object
 */
export const getInitialPreset = (preset, zero = false) => {
  const urlParam = getFromUrl();
  if(urlParam && !zero) {
    try {
      const parsedPreset = parsePreset(urlParam);
      if(parsedPreset) {
        return validatePreset(getPresetTemplate(parsedPreset));
      }
    } catch(e) {
      console.log('Error parsing preset');
    }
  }
  return getPresetTemplate(preset);
};

export const filterPresetProps = preset => {
  let copy = Object.assign({}, preset); // avoid editing reference
  [
    preset => {
      if(l10n.wppr_cjs_ctrl_rotation_active === "no") 
        delete preset.rotate;
      if(l10n.wppr_cjs_ctrl_mirror_active === "no") {
        delete preset.scaleX;
        delete preset.scaleY;
      };
      return preset;
    },
  ].forEach(filter => (copy = filter(copy)));
  return copy;
};

/**
 * Filters preset keys and sets them to default values.
 * @param {Preset} preset - The preset object
 * @returns {Preset} Filtered preset object
 */
export const validatePreset = (preset) => {
  if(!l10n.p_is_repeatable) preset.repeats = 1;
  if(!l10n.p_is_modular) preset.isPattern = false;
  return preset;
};